import { createFileRoute } from '@tanstack/react-router'
import { NewProjectsPage } from '@/components/projects/NewProjectsPage'
import { projectsQueryOptions } from '@/lib/queries'

export const Route = createFileRoute('/_app/projects/')({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(projectsQueryOptions('mine')),
  component: NewProjectsPage,
})
